export default __webpack_public_path__ + "static/media/logo.589675c1.png";